/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
// Utilities
import Container from '../container'
import Button from '../buttons/primary'
import Item from '../header/item'
import MobileItem from './mobileItem'
// Images
import logo from '../../images/logo.svg'
// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandsHelping, faImages, faFileAlt } from '@fortawesome/free-solid-svg-icons'

const Header = () => {
    const [showMenu, setShowMenu] = useState(false)

    useEffect(() => {
        // disable scroll
    })

    return (
        <div>
            {showMenu === true &&
                <div className="mobile-menu absolute w-full h-screen p-5 z-10">
                    <div className="bg-primary-lighter w-full h-screen rounded-md py-7 px-8 z-10">
                        <div>
                            <span onClick={() => showMenu === true ? setShowMenu(false) : setShowMenu(true)} className="cursor-pointer float-right text-gray-100">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </span>
                        </div>
                        <ul>
                            <MobileItem type='link' link='/' title='Home' />
                            <MobileItem type='dropdown' title='Server Hosting'>
                                <li className="w-64 border border-dark shadow-xl rounded-md mb-2.5">
                                    <Link to="/games/minecraft-budget" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        Minecraft Budget EU
                                    </Link>
                                </li>
                                <li className="w-64 border border-dark shadow-xl rounded-md mb-2.5">
                                    <Link to="/games/minecraft" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        Minecraft Premium
                                    </Link>
                                </li>
                                <li className="w-64 border border-dark shadow-xl rounded-md">
                                    <Link to="/games" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        All Game Servers
                                    </Link>
                                </li>
                            </MobileItem>
                            <MobileItem type='dropdown' title='Other Hosting'>
                                <li className="w-64 border border-dark shadow-xl rounded-md mb-2.5">
                                    <Link to="/other/discord" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        Discord Bot
                                    </Link>
                                </li>
                                <li className="w-64 border border-dark shadow-xl rounded-md mb-2.5">
                                    <Link to="/other/web" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        Web Hosting
                                    </Link>
                                </li>
                                <li className="w-64 border border-dark shadow-xl rounded-md mb-2.5">
                                    <Link to="/other" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        All Hosting Options
                                    </Link>
                                </li>
                            </MobileItem>
                            <MobileItem type='dropdown' title='Company'>
                                <li className="w-64 border border-dark shadow-xl rounded-md mb-2.5">
                                    <Link to="/partners" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        Partnerships
                                    </Link>
                                </li>
                                <li className="w-64 border border-dark shadow-xl rounded-md">
                                    <Link to="/jobs" className="block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                        Job Applications
                                    </Link>
                                </li>
                            </MobileItem>
                            <li className="text-gray-300 font-semibold text-xl py-1 mt-8">
                                <Button link='https://billing.stellanode.com/register.php' rounded='lg' arrow={false} length='sm'>Sign up</Button>
                            </li>
                        </ul>
                    </div>
                </div>
            }
            <header className='py-7'>
                <Container>
                    <div className="grid grid-cols-4 items-center">
                        <div className="branding">
                            <Link to='/'>
                                <img src={logo} className="w-60" style={{ minWidth: '15rem' }} alt='StellaNode' />
                            </Link>
                        </div>
                        <div className="navigation hidden sm:hidden md:hidden lg:block col-span-2 text-center">
                            <ul className="flex justify-center">
                                {/* <Item title='Home' type='link' link='/' route={true} /> */}
                                <Item title='Server Hosting' type='dropdown' description='Get a game server and build your online experience.'>
                                <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/games/minecraft-budget-na" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                        Minecraft Budget NA
                                        </Link>
                                    </li>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/games/minecraft-budget-eu" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                        Minecraft Budget EU
                                        </Link>
                                    </li>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/games/minecraft" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                        Minecraft Premium
                                        </Link>
                                    </li>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md">
                                        <Link to="/games" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                            All Game Servers
                                        </Link>
                                    </li>
                                </Item>
                                <Item title='Other Hosting' type='dropdown' description='Explore our non game-server hosting options.'>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/other/discord" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                            Discord Bot
                                        </Link>
                                    </li>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/other/web" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                            Web Hosting
                                        </Link>
                                    </li>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/other" className="hover:bg-primary-light block w-full text-gray-300 text-sm px-4 py-1.5">
                                            All Hosting Options
                                        </Link>
                                    </li>
                                </Item>
                                <Item title='Company' type='dropdown' description='Learn more about our company with the below links.'>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md mb-2.5">
                                        <Link to="/partners" className="hover:bg-primary-light block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                            <FontAwesomeIcon icon={faHandsHelping} className="text-sm text-gray-300 mr-2.5" />
                                            Partnerships
                                        </Link>
                                    </li>
                                    <li className="w-64 border border-primary-light shadow-xl rounded-md">
                                        <Link to="/jobs" className="hover:bg-primary-light block w-full text-gray-300 flex items-center text-sm px-4 py-1.5">
                                            <FontAwesomeIcon icon={faFileAlt} className="text-sm text-gray-300 mr-2.5" />
                                            Job Applications
                                        </Link>
                                    </li>
                                </Item>
                            </ul>
                        </div>
                        <div className="client hidden sm:hidden md:hidden lg:block text-right">
                            <div className="flex float-right">
                                <div className="mr-7">
                                    <a href="https://billing.stellanode.com/login.php" className="text-gray-100 hover:underline text-lg font-medium">Login</a>
                                </div>
                                <div>
                                    <Button link='https://billing.stellanode.com/register.php' rounded='lg' arrow={false} length='sm'>Sign up</Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-3 block sm:block md:block lg:hidden">
                            <div className="mobile-icon cursor-pointer">
                                <div className="mobile-open" onClick={() => setShowMenu(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 float-right text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </header>
        </div>
    )
}

export default Header